export default __webpack_public_path__ + "static/media/sair.7f3098c2.svg";